import React, { Component } from 'react';
import propTypes from 'prop-types';
import className from 'classnames/bind';

import styles from './Seat.module.css';

const cx = className.bind(styles);

class Seat extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }


  render() {

    const seatStyle = cx({
      seat: true,
      disabled: this.props.disabled,
      selected: this.props.selected,
    });

    const selectedSeatStyle = cx({
      surfairBackground: this.props.airline === 'surf air',
      jetsuiteBackground: this.props.airline === 'jet suite x',
      virginBackground: this.props.airline === 'virgin',
      unitedBackground: this.props.airline === 'united',
    })

    const seatStyles = cx({
      seat: true,
      surfairBorder: this.props.airline === 'surf air',
      jetsuiteBorder: this.props.airline === 'jet suite x',
      virginBorder: this.props.airline === 'virgin',
      unitedBorder: this.props.airline === 'united',
      disabled: this.props.disabled,
      rotated: this.props.rotated,
    });

    const seatPos = {
      top: this.props.top ? `${this.props.top}px` : 'initial',
      left: this.props.left ? `${this.props.left}px` : 'initial',
      right: this.props.right ? `${this.props.right}px` : 'initial',
      transform: `scale(${this.props.scale})`,
    };
    return (
      <div
        className={(this.props.children ? styles.recommended : '') +' '+ seatStyles +' '+ (this.props.selected ? selectedSeatStyle : '')}
        style={seatPos}
        onClick={this.props.onToggle}
        data-value={this.props.value}
      >
        {this.props.value}
        { this.props.children ? <span>{this.props.children}</span> : null }
      </div>
    );
  }
}

Seat.defaultProps = {
  left: 'initial',
  right: 'initial',
  scale: 1,
  rotated: false,
};


Seat.propTypes = {
  value: propTypes.string.isRequired,
  onToggle: propTypes.func,
  top: propTypes.oneOfType([propTypes.number, propTypes.string]),
  left: propTypes.oneOfType([propTypes.number, propTypes.string]),
  right: propTypes.oneOfType([propTypes.number, propTypes.string]),
  scale: propTypes.oneOfType([propTypes.number, propTypes.string]),
  rotated: propTypes.bool,
};


export default Seat;



// WEBPACK FOOTER //
// ./src/components/Seats/Seat/Seat.jsx